import type { NextPage } from "next";
import Head from "next/head";
import { useMemo } from "react";
import { PageProvider } from "@providers/page";
import { HydrationBoundary } from "@tanstack/react-query";

import StakeV2 from "@components/V2/Stake";
import { getStakeData } from "@services/gsheets";

export async function getStaticProps() {
  const [availableTags, tokenTagMapping] = await getStakeData();
  return {
    props: {
      availableTags,
      tokenTagMapping,
    },
  };
}

interface PageProps extends Awaited<ReturnType<typeof getStaticProps>> {}

const Restake: NextPage<PageProps["props"]> = ({
  availableTags,
  tokenTagMapping,
}) => {
  const getHeader = useMemo(() => {
    return (
      <Head>
        {/* <title>Kelp</title>
        <meta name="description" content="Kelp" />
        <link rel="icon" href="/favicon.ico" /> */}
        <title>
          Liquid restaking | Restake ETH or LSTs, mint rsETH and earn Kernel
          Points!
        </title>
        <meta
          name="description"
          content="Unlock higher rewards and DeFi utility for restaked assets through liquid restaking with rsETH. Get dual rewards with EigenLayer Restaked Points and Kernel Points."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta property="og:image" content="/restake_preview_image.png" />
        <meta
          property="og:title"
          content=" Liquid restaking | Restake ETH or LSTs, mint rsETH and earn Kernel Points!"
        />
        <meta
          property="og:description"
          content="Unlock higher rewards and DeFi utility for restaked assets through liquid restaking with rsETH. Get dual rewards with EigenLayer Restaked Points and Kernel Points."
        />
      </Head>
    );
  }, []);

  return (
    <PageProvider value={{ pageData: { availableTags, tokenTagMapping } }}>
      {getHeader}
      <HydrationBoundary>
        <StakeV2 />
      </HydrationBoundary>
    </PageProvider>
  );
};

export default Restake;
